module.exports = __webpack_public_path__ + "static/img/call_flow_type_working.f5313408.svg";